export const content = {
    brand: {
      name: 'Zero Emission Power Combustor (ZEPC)',
      shortName: 'ZEPC',
    },
    navigation: {
      links: ['Technology', 'Applications', 'Investment', 'Team'],
      invest: {
        label: 'Invest',
        url: 'https://invown.com/app/pitch/foi',
      },
    },
    hero: {
      title: 'Resilient Power for a Zero‑Emission Future',
      subtitle: 'Zero-carbon, EMP-proof power systems designed to protect critical infrastructure and enable sustainable energy independence.',
      patentText: 'Patent Pending',
    },
    buttons: {
      viewInvestorDeck: 'View Investor Deck',
      
      downloadPitchDeck: 'Download Pitch Deck',
  viewPitchDeck: 'View Pitch Deck',  // ADD THIS
    },

    technology: {
        title: 'The ZEPC System',
        subtitle: 'ZEPC holds an exclusive FOI Group license for a patent pending high-pressure steam generator that converts methane and biomass into clean power.',
        features: [
          {
            title: 'Advanced Boiler System (4000°F)',
            subtitle: 'Combusts a 94% oxygen and methane mixture at over 4000°F inside the boiler, utilizing high-strength materials for efficiency and durability.',
            
          },
          {
            title: 'Dual Heat Transfer Mechanism',
            subtitle: 'Uses cooling fluid on the exterior and water inside to generate high-pressure steam'

            
          },
          {
            title: 'Biomass Integration',
            subtitle: 'Allows combustion of wet biomass due to the natural gas, enhancing energy output and sustainability.'
           
          },
          {
            title: 'Carbon Utilization',
            subtitle:'Captures CO₂ from combustion, which can be used to cultivate algae for biofuel production.'
            
          },
          {
            title: 'Multi-Use Applications',
            subtitle: 'Generates AC electricity with turbines, supports direct DC power for data centers, and offers EMP-proof power solutions for military applications.'
            
          },
          {
            title: 'Refrigeration Potential',
            subtitle: 'Waste heat can be repurposed for absorption refrigeration, ideal for cooling-intensive environments.'
            
          },
        ],
      },
      empDefense: {
        title: 'EMP-Proof Defense Power',
        subtitle: 'Designed to ensure uninterrupted energy supply during EMP events, cyberattacks, and grid failures. Ideal for military and critical infrastructure.',
        comparison: [
          {
            title: 'Traditional Grid Vulnerabilities',
            description: 'Dependent on centralized infrastructure, prone to failure under attack or natural events.',
          },
          {
            title: 'ZEPC Solution',
            description: 'On-site, EMP-shielded low voltage dc generator powered by pressurized water, dual-fuel engine ensures continuous, emission-free power generation.',
          },
        ],
      },

      applications: {
        title: 'Applications',
        items: [
          {
            title: 'Defense & Military',
           
          },
          {
            title: 'Data Centers',
            
          },
          {
            title: 'Agriculture',
            
          },
          {
            title: 'Industrial Cooling',
            
          },
          {
            title: 'Emergency Response',
            
          },
          {
            title: 'Sustainable Communities',
            
          },
        ],
      },
      investment: {
        title: 'Investment Opportunity',
        subtitle: 'A rare opportunity to join the early-stage development of a patented zero-emission and EMP-proof energy system, addressing the urgent global demand for sustainable and resilient power.',

      },

      team: {
        title: 'Leadership Team',
        members: [
          {
            name: 'David Munson Jr.',
            title: 'Founder & CEO',
            email: 'dmunson@foigroup.com',
          },
          {
            name: 'Shawn Flatt',
            title: 'Chief Engineer',
            email: 'shawn.flatt@foigroup.com',
          },
          {
            name: 'Rasneet Singh',
            title: 'Program Manager',
            email: 'rasneetsingh@foigroup.com',
          },
        ],
      },

      footer: {
        copyright: '© 2025 FOI Group, LLC. All rights reserved.',
        links: [
          { text: 'Privacy Policy', url: '#' },
          { text: 'Terms of Use', url: '#' },
        ],
      },
      // Add this to your content object
privacy: {
  title: 'Privacy Policy',
  content: `FOI Group, LLC and its subsidiaries and affiliates (collectively, "FOIG") respect your right to privacy. This Privacy Policy ("Policy") describes the personal information FOIG may collect, use, disclose and otherwise process about individuals, as well as the rights and choices individuals may have regarding their personal information and other important topics relating to your privacy and data protection.

FOIG's policy is to comply with all applicable privacy and data protection laws. This commitment reflects the value we place on earning and keeping the trust of our customers, business partners and others whose personal information we process.

This Policy applies to the personal information we process related to internet sites (each an "Internet Site") and mobile applications (each an "App") operated by or on behalf of FOIG and the services we provide through any Internet Site or App, that may display or include a link to this Policy (collectively the "Services").

[... rest of the privacy policy content ...]

Effective Date: 12 August 2025`,
},
  };